export default __webpack_public_path__ + "static/media/MasterYiHead.2bad02ea.png";